// src/pages/IndirectIncomeBalanceLedger/IndirectIncomeBalanceLedgerSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchIndirectIncomeBalanceLedger,
  fetchIndirectIncomeAccountsBySearch,
} from "./IndirectIncomeBalanceLedgerThunk";

const initialState = {
  list: [],
  loading: false,
  indirectAccounts: [],
  indirectAccountLoading: false,
  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const indirectIncomeBalanceLedgerSlice = createSlice({
  name: "indirectIncomeBalanceLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIndirectIncomeBalanceLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIndirectIncomeBalanceLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchIndirectIncomeBalanceLedger.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchIndirectIncomeAccountsBySearch.pending, (state) => {
        state.indirectAccountLoading = true;
      })
      .addCase(
        fetchIndirectIncomeAccountsBySearch.fulfilled,
        (state, action) => {
          state.indirectAccountLoading = false;
          state.indirectAccounts = action.payload;
        }
      )
      .addCase(fetchIndirectIncomeAccountsBySearch.rejected, (state) => {
        state.indirectAccountLoading = false;
        state.indirectAccounts = [];
      });
  },
});

export const { setFilters } = indirectIncomeBalanceLedgerSlice.actions;
export default indirectIncomeBalanceLedgerSlice.reducer;
